import React from "react";
import { isMobile } from "react-device-detect";
import SkeletonItem from "../../../../../SkeletonItem/SkeletonItem";
import "./ProposalsItemSkeleton.scss";

const ProposalsItemSkeleton = () => {
  return (
    <div className="proposals-item-skeleton">
      <div className="proposals-item-skeleton__basic-info">
        <div className="proposals-item-skeleton__header">
          <div className="proposals-item-skeleton__status-and-link">
            <SkeletonItem width={80} height={35} borderRadius={8} />
            <SkeletonItem width={100} height={35} borderRadius={8} />
            <SkeletonItem width={20} height={20} borderRadius={40} />
          </div>
          <div className="proposals-item-skeleton__name-status">
            <SkeletonItem height={30} width={60} borderRadius={8} />
            <SkeletonItem height={20} width={90} borderRadius={8} />
          </div>
        </div>

        <div className="proposals-item-skeleton__voting">
          <SkeletonItem
            height={80}
            width={isMobile ? 200 : 700}
            borderRadius={8}
          />
          <div className="proposals-item-skeleton__voting-buttons">
            <SkeletonItem height={30} width={60} borderRadius={8} />
            <SkeletonItem height={30} width={60} borderRadius={8} />
          </div>
        </div>
      </div>
      <div className="proposals-item-skeleton__content">
        <SkeletonItem height={35} width={130} borderRadius={8} />
      </div>
    </div>
  );
};

export default ProposalsItemSkeleton;
